
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_gfwv3_1pasn_189",
  "horizontal": "awsui_horizontal_gfwv3_1pasn_192",
  "vertical": "awsui_vertical_gfwv3_1pasn_198",
  "list": "awsui_list_gfwv3_1pasn_203",
  "grid": "awsui_grid_gfwv3_1pasn_222",
  "list-item": "awsui_list-item_gfwv3_1pasn_234",
  "toggle-container-inline": "awsui_toggle-container-inline_gfwv3_1pasn_241",
  "toggle": "awsui_toggle_gfwv3_1pasn_241",
  "description": "awsui_description_gfwv3_1pasn_334",
  "separator": "awsui_separator_gfwv3_1pasn_338"
};
  